import { fetchAPI } from '../../api';
import { Role, User, NewUser } from '../../types';

export const fetchUsers = () => {
  return fetchAPI<User[]>(`v1/users`, {
    method: 'GET',
  });
};

export const fetchPermissions = async () => {
  const permissionsResponse = await fetchAPI<{ permissions: string[] }>(
    `v1/permissions`,
    {
      method: 'GET',
    }
  );
  return permissionsResponse.permissions;
};

export const fetchGroups = () => {
  return fetchAPI<Role[]>(`v1/groups`, {
    method: 'GET',
  });
};

export const saveUserPermissions = (user: User) => {
  return fetchAPI(`v1/users/${user.userId}/permissions`, {
    method: 'PUT',
    body: {
      permissions: user.permissions,
      groups: user.groups,
    },
  });
};

export const deleteUser = (userId: string) => {
  return fetchAPI(`v1/users`, {
    method: 'DELETE',
    body: {
      userId,
    },
  });
};

interface CreateUserResponse {
  userId: string;
}

export const createUser = async (user: NewUser) => {
  const newUser = await fetchAPI<CreateUserResponse>(`v1/users`, {
    method: 'POST',
    body: {
      email: user.email,
    },
  });
  return fetchAPI(`v1/users/${newUser.userId}/permissions`, {
    method: 'PUT',
    body: {
      permissions: user.permissions,
      groups: user.groups,
    },
  });
};
